module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-e764c563d7d1b08b29fb325c01859843.svg";